import { useClickOutsideRef, useFetch } from "Hooks";
import { FC, useEffect, useRef, useState } from "react";
import { TGlobalSearchTermSearchResultGroupHit, TGlobalSearchTermSearchResultTermHit } from "Types";
import { SearchTermGroupHit } from "./SearchTermGroupHit";
import { SearchTermTermHit } from "./SearchTermTermHit";

import styles from "./searchTermGroupSearch.module.scss";

type TSearchTermGroupSearchProps = {
    query: { query: string },
    elementType: string,
    onSingleItemClick?: (text: string) => void,
    onGroupClick?: (id: string, name: string) => void
}

export const SearchTermGroupSearch: FC<TSearchTermGroupSearchProps> = ({ query, elementType, onSingleItemClick, onGroupClick }: TSearchTermGroupSearchProps) => {

    // Ref
    const searchResultsRef = useRef<HTMLDivElement>(null);

    // State
    const [currentQuery, setCurrentQuery] = useState(query.query);

    const resetQuery = () => {
        setCurrentQuery("");
    };

    useClickOutsideRef(searchResultsRef, resetQuery);

    useEffect(() => {
        setCurrentQuery(query.query);
    }, [query]);

    const { fetchedData } = useFetch<(TGlobalSearchTermSearchResultGroupHit | TGlobalSearchTermSearchResultTermHit)[]>
        (`termgroup/searchJson?query=${currentQuery}&elementType=${elementType}`, [currentQuery, elementType]);

    return (
        <div ref={searchResultsRef} className={styles.searchTermGroupContainer}>
            {fetchedData && fetchedData.map((item: TGlobalSearchTermSearchResultGroupHit | TGlobalSearchTermSearchResultTermHit, index: number) => {
                if("text" in item) {
                    const termHit = item as TGlobalSearchTermSearchResultTermHit;
                    return (
                        <SearchTermTermHit termHit={termHit} key={`${termHit.text}-${index}`} onSingleItemClick={onSingleItemClick} />
                    );
                } else {
                    const groupHit = item as TGlobalSearchTermSearchResultGroupHit;
                    return (
                        <SearchTermGroupHit groupHit={groupHit} key={`${groupHit.mainTerm}-${index}`} 
                            onSingleItemClick={onSingleItemClick} onGroupClick={onGroupClick} />
                    );
                }
            })}
        </div>
    );
};